import React, { useState, useEffect } from "react";
import { IoMdCart } from "react-icons/io";
import { useCart } from "../CartContext";
import { FaUserCircle } from "react-icons/fa";
import PhoneInput from "./PhoneInput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { _get } from "../services/apiClient";
import { jwtDecode } from "jwt-decode";

function CartSection({
  size,
  loggedIn,
  setloggedIn,
  form,
  setForm,
  phoneNumber,
  setPhoneNumber,
  pageVisible,
  setPageVisible,
  ordersVisible,
  SetOrdersVisible,
  setCartVisible,
  cartVisible, 
}) {
  const { totalPrice, resetTotalPrice, itemQuantities } = useCart();
  const [isVerified, setIsVerified] = useState(false);
  const [name, setName] = useState(form.name || "");
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const [showPlacedOrderSummary, setShowPlacedOrderSummary] = useState(false);
  

  const cartCount = Object.values(itemQuantities || {}).filter(
    (item) => (item?.quantity || 0) > 0
  ).length;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);

      if (decoded?.id) {
        setloggedIn(true);
        setUserId(decoded.id);

        const fetchUserDetails = async () => {
          try {
            const res = await _get(`/auth/me/${decoded.id}`);
            if (res.data.success) {
              setName(res.data.user.name || "");
              setPhoneNumber(res.data.user.phoneNumber || "");
            }
          } catch (err) {
            console.error("Error fetching user:", err);
          }
        };

        fetchUserDetails();
      }
    } catch (err) {
      console.error("Invalid token:", err);
      setloggedIn(false);
    }
  }, [setloggedIn, setPhoneNumber]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setloggedIn(false);
    SetOrdersVisible(false);
    setPageVisible(false);

    localStorage.removeItem("cartValue");
    localStorage.removeItem("cartQuantityValue");
    resetTotalPrice();

    navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <>
 
      {cartVisible && (
        <div
          className="cart-overlay"
          onClick={() => setCartVisible(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            backdropFilter: "blur(6px)",
            zIndex: 1199, 
          }}
        ></div>
      )}

      <header
        className="section-header d-md-block d-block"
        style={{
          zIndex: 1500,
          background: "#0F4C5C",
          minHeight: "70px",
          padding: "10px 0",
          position: "relative",
        }}
      >
        <section className="header-main shadow-sm">
          <div className="container">
            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="d-flex align-items-center">
                <a
                  href="/"
                  className="d-flex align-items-center"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    fontWeight: 600,
                    fontSize: "16px",
                    gap: "8px",
                  }}
                >
                  <img
                    src={window.location.origin + "/img/logo_web.png"}
                    alt="logo"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                  <span>GoDigex Mart</span>
                </a>
              </div>

              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              
                <div className="text-center">
                  <FaUserCircle
                    onClick={() => {
                      if (!loggedIn) {
                        navigate("/login");
                      }
                    }}
                    style={{
                      fontSize: "30px",
                      color: loggedIn ? "DarkCyan" : "darkred",
                      cursor: "pointer",
                    }}
                  />

                  {!loggedIn ? (
                    <div style={{ color: "orange", fontSize: "14px" }}>
                      Login
                    </div>
                  ) : (
                    <div className="dropdown">
                      <a
                        href="#"
                        className="dropdown-toggle text-light d-block"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style={{ fontSize: "14px" }}
                      >
                        Hi {name}
                      </a>
                      <div
                        className="dropdown-menu dropdown-menu-right"
                        aria-labelledby="dropdownMenuButton"
                      >
                       <a
                          className="dropdown-item"
                          onClick={() => navigate("/orders")} // ✅ new navigation
                          style={{ cursor: "pointer" }}
                        >
                          My Orders
                        </a>
                        <a className="dropdown-item" onClick={handleLogout}>
                          Logout
                        </a>
                      </div>
                    </div>
                  )}
                </div>

               
                <div
                  className="text-center"
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                >
                  <div style={{ position: "relative" }}>
                    <IoMdCart
                      style={{ color: "Salmon", fontSize: "30px" }}
                      onClick={() => {
                        setCartVisible(true);
                        setShowPlacedOrderSummary(true);
                      }}
                    />
                    <div
                      className="border rounded-pill bg-danger px-1 py-0 text-white shadow"
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        fontSize: "12px",
                      }}
                    >
                      {cartCount}
                    </div>
                  </div>
                  <div style={{ color: "orange", fontSize: "14px" }}>
                    My Cart
                  </div>
                </div>
              </div>
            </div>

          
            <div>
              {!loggedIn && pageVisible && (
                <PhoneInput
                  phoneNumber={phoneNumber}
                  form={form}
                  setloggedIn={setloggedIn}
                  setForm={setForm}
                  pageVisible={pageVisible}
                  name={name}
                  setName={setName}
                  setPhoneNumber={setPhoneNumber}
                  setPageVisible={setPageVisible}
                  isVerified={isVerified}
                  setIsVerified={setIsVerified}
                />
              )}
            </div>
          </div>
        </section>
      </header>
    </>
  );
}

export default CartSection;
